import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configService } from './services/configService';
import { initializeAppInsights } from './services/appInsights';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  try {
    await configService.load();

    await initializeAppInsights();

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to bootstrap application:', error);
    root.render(
      <div style={{ padding: '20px', color: 'red' }}>
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration. Please try again.</p>
        <pre>{String(error)}</pre>
      </div>
    );
  }
})();
